import React from 'react';

// [2026-11-01] 관문(약관·공지)의 fail-open 은 팝업 자체의 오류만 통과시키려는 것이다.
//  하위 화면의 오류까지 삼켜 다시 그리면 또 실패하면서 관문이 다시 마운트돼 조회 API 가 초당 수십 번 반복되고
//  화면에는 스피너만 남는다. 그래서 하위 화면 오류에 표시를 남겨 관문 경계가 라우터 오류 화면으로 넘기게 한다.
const childErrors = new WeakSet<object>();

export function isGuardChildError(error: unknown): boolean {
  return typeof error === 'object' && error !== null && childErrors.has(error);
}

interface GuardChildrenProps {
  children?: React.ReactNode;
}

interface GuardChildrenState {
  error?: object;
}

/** 관문이 감싸는 하위 화면 자리 — 여기서 잡힌 오류는 표시만 하고 그대로 다시 던진다 */
export default class GuardChildren extends React.Component<
  GuardChildrenProps,
  GuardChildrenState
> {
  state: GuardChildrenState = {};

  static getDerivedStateFromError(error: unknown): GuardChildrenState {
    const marked =
      typeof error === 'object' && error !== null ? error : new Error(String(error));
    childErrors.add(marked);
    return { error: marked };
  }

  render(): React.ReactNode {
    if (this.state.error) throw this.state.error;
    return this.props.children ?? null;
  }
}
